import React from "react";
import classNames from "classnames/bind";

import styles from "./Banner.module.scss";
const cx = classNames.bind(styles);

const Banner = ({ content }) => {
  return (
    <div className={cx("banner-root")}>
      <p>{content}</p>
    </div>
  );
};

export default Banner;
